export const gamIds = ["2507246", "22928731084"];
export const defaultCols = [
    {
        "key": "childPublisher",
        "title": "Child publisher"
    },
    {
        "key": "parentPublisher",
        "title": "Parent publisher"
    },
    {
        "key": "sellerId",
        "title": "Child seller ID"
    },
    {
        "key": "childNetworkCode",
        "title": "Network code"
    },
    {
        "key": "status",
        "title": "Status"
    },
    {
        "key": "delegation",
        "title": "Delegation"
    },
    {
        "key": "revenueShare",
        "title": "Parent/child rev share"
    }
];

export const accountStatusMap = {
    "INVITED": "Invited",
    "DECLINED": "Declined",
    "PENDING_GOOGLE_APPROVAL": "Pending google approval",
    "APPROVED": "Approved",
    "CLOSED_POLICY_VIOLATION": "Closed policy violation",
    "CLOSED_INVALID_ACTIVITY": "Closed invalid activity",
    "CLOSED_BY_PUBLISHER": "Closed by publisher",
    "DISAPPROVED_INELIGIBLE": "Disapproved ineligible",
    "DISAPPROVED_DUPLICATE_ACCOUNT": "Disapproved duplicate account",
    "EXPIRED": "Expired",
    "INACTIVE": "Inactive",
    "DEACTIVATED_BY_AD_MANAGER": "Deactivated by ad manager"
};

export const delegationMap = {
    "MANAGE_ACCOUNT": "Managed account",
    "MANAGE_INVENTORY": "Managed inventory"
}

export const filters = {
    "delegation": {
        "title":"Delegation",
        "icon":false,
        "initialState":[],
        "items":[
            {"value":"Managed inventory","text":"Managed inventory"},
            {"value":"Managed account","text":"Managed account"}
        ]
    },
    "linked": {
        "title":"Linked",
        "icon":false,
        "initialState":[],
        "items":[
            {"value":"yes","text":"YES"},
            {"value":"no","text":"NO"}
        ]
    },
    "status": {
        "title":"Status",
        "icon":false,
        "initialState":[],
        "items":[
            {"value":"Expired","text":"Expired"},
            {"value":"Invited","text":"Invited"},
            {"value":"Inactive","text":"Inactive"},
            {"value":"Approved","text":"Approved"}
        ]
    }
};

export const defaultFilterObject = {
    "delegation": [],
    "linked": [],
    "status": []
}